
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-mock-test/[slug]",
      function () {
        return require("private-next-pages/open-mock-test/[slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-mock-test/[slug]"])
      });
    }
  